import React from 'react';
import Immutable from 'immutable';
import { useTranslation } from 'react-i18next';

import {
  CoreLink,
  ImageFromField,
} from '@uncinc/react-drupal-core';

import {
  Container,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  SCREEN_MOBILE,
  SCREEN_TABLET,
  SCREEN_WIDE,
} from '../../../config/constants';

import './style.scss';

const Theme = ({ theme, main, isMobile, isDesktop, index, isGrid }) => {
  // We require 4 or 5 themes
  // If these conditionals are confusing, check the Figma design
  let imageStyle;
  if (main || (isMobile && (index === 0))) {
    imageStyle = 'image_grid_square_desktop';
  } else if (isDesktop && !isGrid) {
    imageStyle = '4_3_mobile';
  } else {
    imageStyle = '2_1_landscape_medium';
  }

  return (
    <div className="HighlightedThemes__theme">
      <ImageFromField
        field={Immutable.fromJS(theme.entity.field_media_item[0])}
        imageStyles={Immutable.Map({
          [SCREEN_MOBILE]: imageStyle,
        })}
      />
      <CoreLink to={theme.url}>
        <div className="HighlightedThemes__theme__gradient" />
      </CoreLink>
      <h3 className="HighlightedThemes__theme__name">{theme.entity.name[0].value}</h3>
    </div>
  );
};

const ParagraphHighlightedThemes = ({ id, entity }) => {
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isDesktop = width > SCREEN_WIDE;
  const isMobile = width < SCREEN_TABLET;

  const highlightedThemes = entity.toJS();
  const themes = highlightedThemes.field_themes;
  const link = highlightedThemes.field_link[0];

  const totalThemes = themes.length;

  // depending on the number of themes we have, we would like to display
  // either 1 big theme at the top and the rest below (uneven number of themes)\
  // or a simple grid (even number of themes)
  let mainTheme = null;
  if (totalThemes % 2) {
    mainTheme = themes.shift();
  }

  return (
    <div id={id} className="Paragraph HighlightedThemes">
      <Container>
        <div className="row">
          <div className="col-12 HighlightedThemes__header">
            <h2 className="HighlightedThemes__header__title">
              {t('general.themes')}
            </h2>
            {(link && !isMobile) && (
              <CoreLink
                className="HighlightedThemes__header__link"
                to={link.alias || link.uri}
              >
                <div>
                  {link.title}
                  <i className="icon icon-arrow-right icon-variant-2" />
                </div>
              </CoreLink>
            )}
          </div>
        </div>
        <div className="row">
          {mainTheme && (
            <div className="HighlightedThemes__main col-12 col-md-6 col-lg-5">
              <Theme theme={mainTheme} main />
            </div>
          )}

          {/* Do we have an un-even number of items? That means we will have one main item
          and several 'rest' items */}
          {(totalThemes % 2) ? (
            <div className="HighlightedThemes__rest col-12 col-md-6 col-lg-7">
              {themes.map((theme, index) => {

                // On Mobile and Tablet, we limit the 'rest' items to 2.
                if (!isDesktop && (index > 1)) {
                  return;
                }

                return (
                  <div className="HighlightedThemes__rest__wrapper">
                    <Theme theme={theme} isDesktop={isDesktop} />
                  </div>
                );
              })}
            </div>
          ) : (

            // if we have an even number of items, we can show a simple grid
            <div className="HighlightedThemes__grid">
              {themes.map((theme, index) => {
                // On Mobile and Tablet, we only show 3 items.
                if (isMobile && (index > 2)) {
                  return;
                }

                return (
                  <div className="HighlightedThemes__grid__wrapper col-12 col-md-6">
                    <Theme
                      theme={theme}
                      isMobile={isMobile}
                      isDesktop={isDesktop}
                      index={index}
                      isGrid
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>
        <div className="row">
          <div className="col-12 HighlightedThemes__footer">
            {(link && isMobile) && (
              <CoreLink
                className="HighlightedThemes__header__link"
                to={link.alias || link.uri}
              >
                <div>
                  {link.title}
                  <i className="icon icon-arrow-right icon-variant-2" />
                </div>
              </CoreLink>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphHighlightedThemes;
